import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageWorkingHoursPerPersonTimeSeriesAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/working-hours/account-average-working-hours-per-person-time-series.aggregate-root.mapper';
import { GetAccountAverageWorkingHoursPerPersonTimeSeriesRequestDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-per-person-time-series.request.dto';
import { GetAccountAverageWorkingHoursPerPersonTimeSeriesResponseDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-per-person-time-series.response.dto';
import { GetAccountAverageWorkingHoursPerPersonTimeSeriesQuery } from '../../../queries/org-metrics/working-hours/get-account-average-working-hours-per-person-time-series.query';

export class GetAccountAverageWorkingHoursPerPersonTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageWorkingHoursPerPersonTimeSeriesQuery,
    protected readonly mapper: AccountAverageWorkingHoursPerPersonTimeSeriesAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAverageWorkingHoursPerPersonTimeSeriesRequestDto
  ): Promise<GetAccountAverageWorkingHoursPerPersonTimeSeriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetAccountAverageWorkingHoursPerPersonTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
